
import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Box,
  Grid,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Divider,
  CircularProgress
} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Description as FileIcon } from "@mui/icons-material";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import InfiniteScroll from "react-infinite-scroll-component";
import { Tooltip } from "@mui/material";

import { useLocation } from "react-router-dom";

const IssueNoteInward = ({data}) => {

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <Box>
      <ToastContainer position="top-right" autoClose={3000} />

      {/* Filter Section */}
      
      <TableContainer
        component={Paper}
        id="item-table"
        sx={{
          maxHeight: "48vh",
          overflowX: { xs: "auto", sm: "unset" },
          overflowY: "auto",
          width: "100%",
        }}
      >
        <Table
          stickyHeader
          size="small"
          sx={{
            minWidth: "max-content",
            "& td, & th": {
              borderBottom: "1px solid #ccc",
              textAlign: "center",
              whiteSpace: "nowrap",
              backgroundColor: "#f5f5f5",
            },
          }}
        >
          <TableHead
            sx={{
              "& th": {
                fontWeight: "bold",
                margin: 0,
                color: (theme) =>
                  theme.palette.mode === "dark" ? "#2196f3" : "#333",
                backgroundColor: (theme) =>
                  theme.palette.mode === "dark" ? "black" : "#f5f5f5",
              },
            }}
          >
            <TableRow>
              <TableCell
                sx={{
                  position: "sticky",
                  left: 0,
                  backgroundColor: "#f5f5f5",
                  zIndex: 3,
                  minWidth: 40,
                  padding: "0px",
                }}
              >
                S. No.
              </TableCell>
              <TableCell>Date</TableCell>
              <TableCell>GRN No</TableCell>
              <TableCell>PO No</TableCell>
              <TableCell align="right">Supplier Name</TableCell>
              <TableCell>Category</TableCell>
              {/* <TableCell>Sub Category</TableCell> */}
              {/* <TableCell>Item Type</TableCell> */}
              <TableCell align="right">Item Name</TableCell>
              <TableCell>Rec Qty</TableCell>
              <TableCell>Rem Qty</TableCell>
              <TableCell align="right">Rate</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {data && data.length > 0 ? (
              data.map((voucher, voucherIndex) => {
                // Check if items array exists and has length
                if (!voucher || !voucher.items || !Array.isArray(voucher.items)) {
                  return null; // Skip this voucher if items is missing
                }

                const itemCount = voucher.items.length;

                // If no items, skip this voucher
                if (itemCount === 0) {
                  return null;
                }

                return (
                  <React.Fragment key={voucherIndex}>
                    {voucher.items.map((item, itemIndex) => (
                      <TableRow
                        hover
                        key={`${voucherIndex}-${itemIndex}`}
                        sx={{
                          backgroundColor: voucherIndex % 2 === 0 ? "#fafafa" : "#ffffff",
                          "&:hover": {
                            backgroundColor: "#e3f2fd",
                            "& td": { backgroundColor: "#e3f2fd !important" },
                          },
                          "& td": {
                            paddingTop: "2px !important",
                            paddingBottom: "2px !important",
                            fontSize: { xs: "0.75rem", sm: "0.8125rem" },
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            color: (theme) =>
                              theme.palette.mode === "dark" ? "white" : "inherit",
                          },
                        }}
                      >
                        {itemIndex === 0 && (
                          <TableCell
                            align="center"
                            rowSpan={itemCount}
                            sx={{
                              position: "sticky",
                              left: 0,
                              backgroundColor: voucherIndex % 2 === 0 ? "#fafafa !important" : "#ffffff !important",
                              zIndex: 2,
                              minWidth: 50,
                            }}
                          >
                            {voucherIndex + 1}
                          </TableCell>
                        )}

                        {itemIndex === 0 && (
                          <TableCell
                            rowSpan={itemCount}
                            sx={{
                              backgroundColor: voucherIndex % 2 === 0 ? "#fafafa !important" : "#ffffff !important",
                            }}
                          >
                            {formatDate(voucher.created_at)}
                          </TableCell>
                        )}

                        {itemIndex === 0 && (
                          <TableCell
                            rowSpan={itemCount}
                            sx={{
                              backgroundColor: voucherIndex % 2 === 0 ? "#fafafa !important" : "#ffffff !important",
                            }}
                          >
                            {voucher.grn_no || "-"}
                          </TableCell>
                        )}

                        {itemIndex === 0 && (
                          <TableCell
                            align="right"
                            rowSpan={itemCount}
                            sx={{
                              backgroundColor: voucherIndex % 2 === 0 ? "#fafafa !important" : "#ffffff !important",
                            }}
                          >
                            {voucher.purchase_order || "-"}
                          </TableCell>
                        )}

                        {itemIndex === 0 && (
                          <TableCell
                            align="right"
                            rowSpan={itemCount}
                            sx={{
                              backgroundColor: voucherIndex % 2 === 0 ? "#fafafa !important" : "#ffffff !important",
                            }}
                          >
                            {voucher.supplier_name || "-"}
                          </TableCell>
                        )}

                        <TableCell sx={{
                          backgroundColor: voucherIndex % 2 === 0 ? "#fafafa !important" : "#ffffff !important",
                        }}>
                          {item?.category_name || "-"}
                        </TableCell>
                        {/* <TableCell sx={{
                          backgroundColor: voucherIndex % 2 === 0 ? "#fafafa !important" : "#ffffff !important",
                        }}>
                          {item?.sub_category_name || "-"}
                        </TableCell> */}
                        {/* <TableCell sx={{
                          backgroundColor: voucherIndex % 2 === 0 ? "#fafafa !important" : "#ffffff !important",
                        }}>
                          {item?.item_type || "-"}
                        </TableCell> */}
                        <TableCell sx={{
                          backgroundColor: voucherIndex % 2 === 0 ? "#fafafa !important" : "#ffffff !important",
                        }} align="right">
                          {item?.item_name || "-"}
                        </TableCell>
                        <TableCell sx={{
                          backgroundColor: voucherIndex % 2 === 0 ? "#fafafa !important" : "#ffffff !important",
                        }}>
                          {item?.received_qty || 0}
                        </TableCell>
                        <TableCell sx={{
                          backgroundColor: voucherIndex % 2 === 0 ? "#fafafa !important" : "#ffffff !important",
                        }} align="right">
                          {item?.rejected_qty || 0}
                        </TableCell>
                        <TableCell sx={{
                          backgroundColor: voucherIndex % 2 === 0 ? "#fafafa !important" : "#ffffff !important",
                        }} align="right">
                          {item?.rate || 0}
                        </TableCell>
                      </TableRow>
                    ))}
                  </React.Fragment>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={12} align="center">
                  No data available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default IssueNoteInward;